module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3780f868"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/authentication/AuthCommon.vue
// module id = 369
// module chunks = 42